export default ({
  data: { order, updatedAt }
}) => {
  return {
    editorBlocksOrder: order,
    editorHeaderStatus: 'saved',
    editorHeaderUpdatedAt: updatedAt,
    editorIsDraft: true
  }; 
};
